import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';

// Create and export Redux store using root reducer (combined reducer) and redux thunk
export default createStore(rootReducer, applyMiddleware(thunk));